import { useCallback, useRef, useState } from 'react';
import produce from 'immer';
import './App.css';


const gridRows = 50;
const gridCols = 50;
const calcNeighbors = [
  [0,1],[0,-1],[1,-1],[-1,1],[1,1],[-1,-1],[1,0],[-1,0]
]

const emptyGrid = () => {
  const rows = [];
    for(let i = 0; i < gridRows; i++) {
      rows.push(Array.from(Array(gridCols), () => 0))
    }

    return rows
}

function App() {
  const [grid, setGrid] = useState(() => {
    
    return emptyGrid()
  });
  
  const [running, setRunning] = useState(false)

  const runRef = useRef(running)
  runRef.current = running

  const runSim = useCallback(() => {
    if(!runRef.current){
      return
    }

    setGrid((g) => {
      // g represents the current grid
      return produce(g, gridCopy => {
        //for each cell in the grid, compute the number of neighbors it has
        for(let i = 0; i < gridRows; i++){
          for(let j = 0;j < gridCols; j++){
            let neighbors = 0;
            calcNeighbors.forEach(([x,y]) => {
              const newI = i + x;
              const newJ = j + y;
              // makes sure we stay within the boundaries of the grid
              if(newI >= 0 && newI < gridRows && newJ >= 0 && newJ < gridCols){
                neighbors += g[newI][newJ]
              }
            })
            //Any live cell with fewer than two live neighbours dies, as if by underpopulation.
            //Any live cell with more than three live neighbours dies, as if by overpopulation.
            if(neighbors < 2 || neighbors > 3){
              gridCopy[i][j] = 0;
            }else if(g[i][j] === 0 && neighbors === 3 ){
              //Any dead cell with exactly three live neighbours becomes a live cell, as if by reproduction
              gridCopy[i][j] = 1
            }
          }
        }
      })
    })

    setTimeout(runSim, 100)
  }, [])
  
  return (
    <>
      <div style={{
        padding: '10px',
        display: 'flex',
        justifyContent: 'center'
      }}>
        <button style={{marginRight: '20px'}} 
          onClick={() => {
            setRunning(!running);
            if(!running){
              runRef.current = true; 
              runSim()}}
            }>
        {!running ? "Start" : "Stop"}
        </button>
        <button style={{marginRight: '20px'}} onClick={() => {
          setGrid(emptyGrid())
        }}>
          Clear
        </button>
        <button style={{marginRight: '20px'}} onClick={() => {
          const rows = [];
          for(let i = 0; i < gridRows; i++) {
            rows.push(Array.from(Array(gridCols), () => (Math.random() > 0.7 ? 1 : 0)))
          }
      
          setGrid(rows)
        }}>
          Random
        </button>
      </div>
      <h2 style={{textAlign:'center'}}>Conway's Game of Life</h2>
      <div style={{
        display:'flex',
        justifyContent:'center',
        marginTop: '1em'
      }} >
        <div style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${gridCols}, 20px)`
        }}>
          {grid.map((rows, i) => rows.map((col, j) => 
            <div onClick={() => {
                const newGrid = produce(grid, gridCopy => {
                  gridCopy[i][j] = gridCopy[i][j] ? 0 : 1
                })
                setGrid(newGrid)
              }} 
              key={`${i}-${j}`} 
              style={{
                width: 20, 
                height: 20, 
                backgroundColor: grid[i][j] ? 'white' : undefined, 
                border: "solid 1px white" 
                }} 
            />))}
        </div>
      </div>
    </>
  );
}

export default App;
